(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Touch devices have no hover: first tap previews the product, second tap opens it.
    if (!window.matchMedia('(hover: none)').matches) return;

    document.addEventListener('click', function (event) {
      var dot = event.target.closest('.shop-the-look__dot');
      document.querySelectorAll('.shop-the-look__spot.is-active').forEach(function (spot) {
        if (!dot || spot !== dot.parentElement) spot.classList.remove('is-active');
      });
      if (!dot) return;

      var spot = dot.parentElement;
      if (!spot.classList.contains('is-active')) {
        event.preventDefault();
        spot.classList.add('is-active');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
